import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { CustomerProvider } from './context/CustomerContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import Home from './pages/Home';
import Shop from './pages/Shop';
import CategoryPage from './pages/CategoryPage';
import ProductDetail from './pages/ProductDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import DealerSignup from './pages/DealerSignup';
import FAQ from './pages/FAQ';
import Resources from './pages/Resources';
import MeasuringGuide from './pages/MeasuringGuide';
import InstallationGuide from './pages/InstallationGuide';
import AdminApp from './admin/AdminApp';
import DealerApp from './dealer/DealerApp';

// Domains that should load dealer portal directly (no retail content)
const DEALER_DOMAINS = ['wittdealer.com', 'www.wittdealer.com'];

function isDealerDomain() {
  return DEALER_DOMAINS.includes(window.location.hostname);
}
import Checkout from './pages/Checkout';
import CheckoutSuccess from './pages/CheckoutSuccess';
import AccountLogin from './pages/account/AccountLogin';
import AccountRegister from './pages/account/AccountRegister';
import AccountDashboard from './pages/account/AccountDashboard';
import AccountProfile from './pages/account/AccountProfile';
import AccountOrderDetail from './pages/account/AccountOrderDetail';

function PublicLayout() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white font-inter">
      <Navbar />
      <CartDrawer />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/suppressors" element={<CategoryPage categorySlug="suppressors" />} />
          <Route path="/sound-mitigation-equipment" element={<CategoryPage categorySlug="sound-mitigation-equipment" />} />
          <Route path="/muzzle-devices" element={<CategoryPage categorySlug="muzzle-devices" />} />
          <Route path="/clamp-ons" element={<CategoryPage categorySlug="clamp-ons" />} />
          <Route path="/product/:slug" element={<ProductDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/dealer-signup" element={<DealerSignup />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/resources/faq" element={<FAQ />} />
          <Route path="/resources/measuring" element={<MeasuringGuide />} />
          <Route path="/resources/installation" element={<InstallationGuide />} />
          {/* Checkout */}
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          {/* Customer Account */}
          <Route path="/account/login" element={<AccountLogin />} />
          <Route path="/account/register" element={<AccountRegister />} />
          <Route path="/account" element={<AccountDashboard />} />
          <Route path="/account/profile" element={<AccountProfile />} />
          <Route path="/account/orders/:id" element={<AccountOrderDetail />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <CustomerProvider>
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/admin/*"  element={<AdminApp />} />
            <Route path="/dealer/*" element={<DealerApp />} />
            <Route path="/retail/*" element={<PublicLayout />} />
            <Route path="/*" element={
              isDealerDomain()
                ? <Navigate to="/dealer/login" replace />
                : <PublicLayout />
            } />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </CustomerProvider>
  );
}

export default App;
